import { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Hook compartido: canales de venta configurados (POS, filtros de Inventario/Pedidos/
// Resumen/Gastos, Configuración). Reemplaza la lista fija de canales. Cada canal trae
// `status`: 'permanent' | 'active' | 'upcoming' | 'finished'. `includeArchived` trae
// también los canales archivados (para consultar histórico en filtros).
export default function useSalesChannels({ includeArchived = false } = {}) {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    let cancelled = false;
    setLoading(true);
    fetch(`${API_URL}/api/sales-channels?includeArchived=${includeArchived ? 1 : 0}`)
      .then((r) => (r.ok ? r.json() : { channels: [] }))
      .then((d) => { if (!cancelled) { setChannels(d.channels || []); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [includeArchived]);

  useEffect(() => load(), [load]);

  return { channels, loading, reload: load };
}
